export default "__VITE_ASSET__Ds7q6EJ4__"